/**
 * Mobiles Menü als Akkordeon — die zwei Dinge, die CSS allein nicht kann
 * (2026-08-24). Das Aufklappen selbst macht `component-menu-drawer.css`.
 *
 * Dawns `global.js` bleibt unangetastet.
 */
(function () {
  /* ------------------------------------------------------------------
     1. Tastaturfokus nicht im Untermenü einsperren
     ------------------------------------------------------------------
     `MenuDrawer.onSummaryClick()` ruft beim Öffnen eines Untermenüs
     `trapFocus(...)` auf. Das ist richtig, solange das Untermenü eine
     eingeschobene Vollflächen-Seite ist — beim Akkordeon stehen beide
     Ebenen gleichzeitig da, und der Fokus muss sie weiter durchlaufen
     können. Dawn ruft trapFocus verzögert auf (setTimeout 100 bzw. nach
     `transitionend`), deshalb geben wir den Fokus mit etwas Nachlauf
     wieder frei. */
  function fokusFreigeben() {
    if (typeof window.removeTrapFocus !== 'function') return;
    window.setTimeout(function () {
      window.removeTrapFocus();
    }, 250);
    window.setTimeout(function () {
      window.removeTrapFocus();
    }, 700);
  }

  /* ------------------------------------------------------------------
     2. Höhe des Menüs an die tatsächliche Oberkante binden
     ------------------------------------------------------------------
     Das CSS rechnete mit `calc(100dvh - 95px)` — einer festen Annahme über
     die Höhe des Kopfbereichs. Stimmt sie nicht, bleibt unten ein Streifen
     frei (am iPhone gemeldet) oder das Menü ragt über den Rand. Der Wert
     wird deshalb gemessen: Das Menü ist `position: absolute; top: 100%`,
     seine Oberkante ist also die Unterkante des Kopfbereichs. */
  function hoeheSetzen() {
    var menue = document.querySelector('.menu-drawer');
    if (!menue) return;
    /* Die Oberkante des MENÜS selbst messen, nicht die Unterkante seines
       Containers: Zwischen beiden liegen im Theme 14 px (Rand/Abstand), und
       mit dem Container-Wert ragte das Menü genau um diese 14 px über den
       unteren Fensterrand hinaus (gemessen 2026-08-24).
       Im zugeklappten Zustand ist das Menü nur per `translateX` zur Seite
       geschoben — die Y-Position stimmt also auch dann. */
    var oben = Math.round(menue.getBoundingClientRect().top);
    if (oben < 0 || oben > window.innerHeight) return; /* gescrollt: Wert unbrauchbar */
    document.documentElement.style.setProperty('--wb-drawer-top', oben + 'px');
  }

  /* ------------------------------------------------------------------
     3. :active am Handy freischalten (2026-09-03)
     ------------------------------------------------------------------
     iOS Safari wendet :active bei Berührung nur an, wenn irgendwo im
     Element oder darüber ein touchstart-Handler hängt — ein leerer genügt.
     Die Tipp-Rückmeldung der Menüzeilen (component-menu-drawer.css) hängt
     daran. */
  function tippRueckmeldungFreischalten() {
    var menue = document.querySelector('.menu-drawer');
    if (!menue) return;
    menue.addEventListener('touchstart', function () {}, { passive: true });
  }

  function start() {
    hoeheSetzen();
    tippRueckmeldungFreischalten();

    /* Beim Öffnen des Menüs neu messen (Kopfbereich kann sich geändert
       haben, etwa durch die Suchleiste) und den Fokus freigeben. */
    document.addEventListener('click', function (ereignis) {
      var ziel = ereignis.target;
      if (!ziel || !ziel.closest) return;
      if (!ziel.closest('.menu-drawer-container')) return;
      window.setTimeout(hoeheSetzen, 50);
      if (ziel.closest('summary')) fokusFreigeben();
    });

    window.addEventListener('resize', hoeheSetzen);
    window.addEventListener('orientationchange', function () {
      window.setTimeout(hoeheSetzen, 250);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
